import React, { useState, useRef } from "react";
import { Chart } from "primereact/chart";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Carousel } from 'primereact/carousel';
import { Menu } from 'primereact/menu';
import { useNavigate } from "react-router-dom";
import UsuariosDialog from "../components/dialogs/UsuariosDialog";
import CotizacionesDialog from "../components/dialogs/CotizacionesDialog";
import CotizacionesEnviadasDialog from "../components/dialogs/CotizacionesEnviadasDialog";
import AbiertasGanadasDialog from "../components/dialogs/AbiertasGanadasDialog";
import CoberturaDialog from "../components/dialogs/CoberturaDialog";
import GanadasPerdidasDialog from "../components/dialogs/GanadasPerdidasDialog";
import { chartData, chartOptions, goalChartOptions } from "./TableroConfig";

const Tablero = () => {
  const [activeTab, setActiveTab] = useState("Mayorista");
  const [isUsuariosDialogVisible, setIsUsuariosDialogVisible] = useState(false);
  const [isCotizacionesDialogVisible, setIsCotizacionesDialogVisible] = useState(false);
  const [isCotizacionesEnviadasDialogVisible, setIsCotizacionesEnviadasDialogVisible] = useState(false);
  const [isAbiertasGanadasDialogVisible, setIsAbiertasGanadasDialogVisible] = useState(false);
  const [isCoberturaDialogVisible, setIsCoberturaDialogVisible] = useState(false);
  const [isGanadasPerdidasDialogVisible, setIsGanadasPerdidasDialogVisible] = useState(false);

  // Mock Data for Charts

  // Mock Data for Lists
  const vendedoresData = [
    { rank: 1, name: "Lily Ampar Farfan Flores", value: 2 },
  ];

  const familiasData = [
    { rank: "1.-", name: "10602", value: 0 },
  ];

  const topVendedoresData = [
    { rank: "1.-", name: "Lily Ampar Farfan Flores", value: 0 },
  ];

  // Mock Data for Goals Charts
  const chartGoalsVendedor = {
    labels: ['Meta Personal'],
    datasets: [
        {
            label: 'Cumplimiento',
            backgroundColor: '#42A5F5',
            data: [75]
        },
        {
            label: 'Meta',
            backgroundColor: '#FFCDD2',
            data: [100]
        }
    ]
  };

  const chartGoalsJefe = {
      labels: ['Vendedor 1', 'Vendedor 2', 'Vendedor 3', 'Vendedor 4', 'Vendedor 5'],
      datasets: [
          {
              label: 'Cumplimiento',
              backgroundColor: '#66BB6A',
              data: [65, 59, 80, 81, 56]
          },
          {
            label: 'Meta',
            backgroundColor: '#FFCDD2',
            data: [100, 100, 100, 100, 100]
        }
      ]
  };

  const chartGoalsAdmin = {
      labels: ['Equipo A', 'Equipo B', 'Equipo C'],
      datasets: [
          {
              label: 'Cumplimiento',
              backgroundColor: '#FFA726',
              data: [28, 48, 40]
          },
          {
            label: 'Meta',
            backgroundColor: '#FFCDD2',
            data: [100, 100, 100]
        }
      ]
  };

  const navigate = useNavigate();
  const menu = useRef(null);
  const items = [
    {
      label: 'Ingresar Cotización Boleta',
      icon: 'pi pi-file',
      command: () => {
        navigate('/boleta');
      }
    },
    {
      label: 'Ingresar Cotización Factura',
      icon: 'pi pi-file-o',
      command: () => {
        navigate('/factura');
      }
    }
  ];

  const chartsResponsiveOptions = [
    {
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1
    },
    {
        breakpoint: '991px',
        numVisible: 1,
        numScroll: 1
    },
    {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1
    }
  ];

  const chartTemplate = (item) => {
    return (
        <div className="flex flex-column align-items-center p-2 w-full">
             <h5 className="text-blue-500 mb-3">{item.title}</h5>
             {item.content}
        </div>
    );
  }

  const chartCarouselItems = [
      {
          title: 'Tasas de Cierre',
          content: <Chart type="bar" data={chartData} options={chartOptions} style={{ height: '300px', width: '100%' }} />
      },
      {
          title: '¿Cómo vamos? - Cumplimiento Vendedor',
          content: (
            <div className="flex flex-column align-items-center w-full">
                 <h6 className="m-0 mb-2">Mi Cumplimiento</h6>
                 <Chart type="bar" data={chartGoalsVendedor} options={goalChartOptions} style={{ width: '100%', height: '300px' }} />
            </div>
          )
      },
      {
          title: '¿Cómo vamos? - Cumplimiento Jefe',
          content: (
            <div className="flex flex-column align-items-center w-full">
                <h6 className="m-0 mb-2">Cumplimiento del Equipo</h6>
                <Chart type="bar" data={chartGoalsJefe} options={goalChartOptions} style={{ width: '100%', height: '300px' }} />
            </div>
          )
      },
      {
          title: '¿Cómo vamos? - Cumplimiento Administrador',
          content: (
             <div className="flex flex-column align-items-center w-full">
                <h6 className="m-0 mb-2">Cumplimiento por Equipos</h6>
                <Chart type="bar" data={chartGoalsAdmin} options={goalChartOptions} style={{ width: '100%', height: '300px' }} />
            </div>
          )
      }
  ];

  return (
    <div className="grid">
      <div className="col-12"> 
        {/* Tabs */}
        <div className="flex justify-content-between mb-3">
          <div className="flex">
            <Button 
              label="Mayorista" 
              className={`mr-1 ${activeTab === "Mayorista" ? "p-button-info" : "p-button-secondary p-button-outlined"}`} 
              onClick={() => setActiveTab("Mayorista")} 
              icon="pi pi-shopping-cart"
            />
            <Button 
              label="Retail" 
              className={activeTab === "Retail" ? "p-button-info" : "p-button-secondary p-button-outlined"} 
              onClick={() => setActiveTab("Retail")} 
              icon="pi pi-shopping-cart"
            />
          </div>
          <div>
            <Menu model={items} popup ref={menu} id="popup_menu" />
            <Button
              label="Nuevo" 
              className={"p-button-success"} 
              onClick={(event) => menu.current.toggle(event)} 
              icon="pi pi-plus"
              aria-controls="popup_menu"
              aria-haspopup
            />
          </div>
        </div>

        {/* KPI Cards Section */}
        <div className="grid">
            {/* Card 1: Usuarios Activos */}
            <div className="col-12 md:col-6 lg:col-2">
                <div 
                  className="surface-0 shadow-2 p-3 border-round h-full flex flex-column justify-content-between rounded-md cursor-pointer hover:surface-50 transition-all transition-duration-200"
                  onClick={() => setIsUsuariosDialogVisible(true)}
                >
                    <div className="flex align-items-center mb-2">
                      <div className="p-2 border-round mr-2">
                        <i className="pi pi-users text-xl text-blue-500"/>
                      </div>
                      <span className="text-lg font-bold text-900">Usuarios</span>
                    </div>  
                    
                    <div className="flex flex-column gap-3">
                      <div className="flex justify-content-between align-items-center">
                        <div className="flex flex-column">
                          <span className="text-500 text-sm">Activos</span>
                          <div className="flex align-items-baseline">
                            <span className="text-2xl font-bold text-900">9</span>
                            <span className="text-500 text-xs ml-1">/ 80</span>
                          </div>
                        </div>
                        <i className="pi pi-check-circle text-green-500 text-xl"></i>
                      </div>

                      <div className="surface-200 w-full" style={{ height: '4px' }}>
                        <div className="bg-blue-500 h-full" style={{ width: '11%' }}></div>
                      </div>

                      <div className="flex justify-content-between align-items-center">
                        <div className="flex flex-column">
                          <span className="text-500 text-sm">Zonas</span>
                          <div className="flex align-items-baseline">
                            <span className="text-2xl font-bold text-900">1</span>
                            <span className="text-500 text-xs ml-1">/ 10</span>
                          </div>
                        </div>
                        <i className="pi pi-map-marker text-orange-500 text-xl"></i>
                      </div>
                    </div>
                </div>
            </div>

            {/* Card 2: Cotizaciones */}
            <div className="col-12 md:col-6 lg:col-2">
                <div 
                  className="surface-0 shadow-2 p-3 border-round h-full flex flex-column justify-content-between rounded-md cursor-pointer hover:surface-50 transition-all transition-duration-200"
                  onClick={() => setIsCotizacionesDialogVisible(true)}
                >
                    <div className="flex align-items-center mb-2">
                      <div className="p-2 border-round mr-2">
                        <i className="pi pi-file text-xl text-blue-500"/>
                      </div>
                      <span className="text-lg font-bold text-900">Cotizaciones</span>
                    </div>  
                      
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">generadas del 02/10/2025 al 02/01/2026</div>
                          <div className="text-xl font-bold">2</div>
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Última cotización</div>
                          <div className="text-xl font-bold">11:20</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Card 3: Ultimos 30 dias */}
            <div className="col-12 md:col-6 lg:col-2">
              <div 
                  className="surface-0 shadow-2 p-3 border-round h-full flex flex-column justify-content-between rounded-md cursor-pointer hover:surface-50 transition-all transition-duration-200"
                  onClick={() => setIsCotizacionesEnviadasDialogVisible(true)}
              >

                    <div className="flex align-items-center mb-2">
                      <div className="p-2 border-round mr-2">
                        <i className="pi pi-envelope text-xl text-blue-500"/>
                      </div>
                      <span className="text-lg font-bold text-900">Enviadas</span>
                    </div> 

                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Últimos 30 días</div>
                          <div className="text-xl font-bold">2</div>
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Evolución del mes</div>
                          <div className="text-xl font-bold">2</div>
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Esta semana</div>
                          <div className="text-xl font-bold">1</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Card 4: Abiertas/Ganadas */}
            <div className="col-12 md:col-6 lg:col-2">
              <div 
                  className="surface-0 shadow-2 p-3 border-round h-full flex flex-column justify-content-between rounded-md cursor-pointer hover:surface-50 transition-all transition-duration-200"
                  onClick={() => setIsAbiertasGanadasDialogVisible(true)}>
                    <div className="flex align-items-center mb-2">
                      <div className="p-2 border-round mr-2">
                        <i className="pi pi-list text-xl text-blue-500"/>
                      </div>
                      <span className="text-lg font-bold text-900">Estado</span>
                    </div> 
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Abiertas</div>
                          <div className="text-xl font-bold">2</div>
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Ganadas</div>
                          <div className="text-xl font-bold">2</div>
                        </div>
                    </div>
                </div>
            </div>

             {/* Card 5: Cobertura */}
            <div className="col-12 md:col-6 lg:col-2">
                <div 
                  className="surface-0 shadow-2 p-3 border-round h-full flex flex-column justify-content-between rounded-md cursor-pointer hover:surface-50 transition-all transition-duration-200"
                  onClick={() => setIsCoberturaDialogVisible(true)}
                >

                    <div className="flex align-items-center mb-2">
                      <div className="p-2 border-round mr-2">
                        <i className="pi pi-chart-pie text-xl text-blue-500"/>
                      </div>
                      <span className="text-lg font-bold text-900">Cartera de clientes</span>
                    </div> 

                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Cobertura enero</div>
                          <div className="text-xl font-bold">1%</div>
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Cobertura diciembre</div>
                          <div className="text-xl font-bold">2%</div>
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Cobertura noviembre</div>
                          <div className="text-xl font-bold">2%</div>
                        </div>
                    </div>
                </div>
            </div>

             {/* Card 6: Cotizaciones Ganadas/Perdidas */}
            <div className="col-12 md:col-6 lg:col-2">
                <div 
                  className="surface-0 shadow-2 p-3 border-round h-full flex flex-column justify-content-between rounded-md cursor-pointer hover:surface-50 transition-all transition-duration-200"
                  onClick={() => setIsGanadasPerdidasDialogVisible(true)}
                >
                    <div className="flex align-items-center mb-2">
                      <div className="p-2 border-round mr-2">
                        <i className="pi pi-dollar text-xl text-blue-500"/>
                      </div>
                      <span className="text-lg font-bold text-900">Montos</span>
                    </div> 
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Ganados (30d)</div>
                          <div className="text-xl font-bold">1.000.000</div>
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-start">  
                        <div className="text-left">
                          <div className="text-500 text-gray-500">Perdidos (30d)</div>
                          <div className="text-xl font-bold">1.000.000</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Charts and Lists Section */}

        <div className="grid">

            {/* Left Column: Tasas de Cierre & Cumplimiento de Metas */}
            <div className="col-12 lg:col-6">
                <div className="card h-full">
                    <Carousel value={chartCarouselItems} numVisible={1} numScroll={1} responsiveOptions={chartsResponsiveOptions} itemTemplate={chartTemplate} autoplayInterval={4000} circular />
                </div>
            </div>

            {/* Familias and Top Vendedores */}
            <div className="col-12 lg:col-6">
                <div className="card">
                    <h6 className="text-blue-500">Rendimiento por Vendedor</h6>
                    <DataTable value={vendedoresData} className="p-datatable-sm" showHeaders={false}>
                        <Column field="rank" style={{width: '20px'}}></Column>
                        <Column field="name"></Column>
                        <Column field="value" className="text-right"></Column>
                    </DataTable>
                </div>
                <div className="card">
                    <h6 className="text-blue-500">Familias mas vendidas (Ton)</h6>
                    <DataTable value={familiasData} className="p-datatable-sm" showHeaders={false}>
                        <Column field="rank" style={{width: '30px'}}></Column>
                        <Column field="name"></Column>
                        <Column field="value" className="text-right"></Column>
                    </DataTable>
                </div>
                <div className="card">
                    <h6 className="text-blue-500">Top 10 vendedores (M$)</h6>
                    <DataTable value={topVendedoresData} className="p-datatable-sm" showHeaders={false}>
                        <Column field="rank" style={{width: '30px'}}></Column>
                        <Column field="name"></Column>
                        <Column field="value" className="text-right"></Column>
                    </DataTable>
                </div>
                
                <div className="card">
                  <h6 className="text-blue-500">Compras cerradas últimos 3 meses</h6>
                  <div className="grid grid-nogutter p-3 text-center">
                      <div className="col-4 border-right-1 surface-border">
                          <div className="text-3xl font-bold text-blue-600">M$0</div>
                          <div className="text-500">octubre</div>
                      </div>
                      <div className="col-4 border-right-1 surface-border">
                          <div className="text-3xl font-bold text-blue-600">M$0</div>
                          <div className="text-500">noviembre</div>
                      </div>
                      <div className="col-4">
                          <div className="text-3xl font-bold text-blue-600">M$0</div>
                          <div className="text-500">diciembre</div>
                      </div>
                  </div>
                </div>
          </div>
        </div>
      </div>

      <UsuariosDialog 
          visible={isUsuariosDialogVisible} 
          onHide={() => setIsUsuariosDialogVisible(false)} 
      />
      <CotizacionesDialog 
          visible={isCotizacionesDialogVisible} 
          onHide={() => setIsCotizacionesDialogVisible(false)} 
      />
      <CotizacionesEnviadasDialog 
          visible={isCotizacionesEnviadasDialogVisible} 
          onHide={() => setIsCotizacionesEnviadasDialogVisible(false)} 
      />
      <AbiertasGanadasDialog 
          visible={isAbiertasGanadasDialogVisible} 
          onHide={() => setIsAbiertasGanadasDialogVisible(false)} 
      />
      <CoberturaDialog 
          visible={isCoberturaDialogVisible} 
          onHide={() => setIsCoberturaDialogVisible(false)} 
      />
      <GanadasPerdidasDialog 
          visible={isGanadasPerdidasDialogVisible} 
          onHide={() => setIsGanadasPerdidasDialogVisible(false)} 
      />
    </div>
  );
};

export default Tablero;
